var Tariff = /*@__PURE__*/ (function () {
    function Tariff(data) {
        this.type = 'tariffMobile';
        if (data) {
            if (data.id) {
                this.id = parseInt(data.id, 10);
            }
            if (data.label) {
                this.label = data.label;
            }
            if (data.topSmartphoneDeals) {
                this.topSmartphoneDeals = data.topSmartphoneDeals;
            }
            if (data.additional) {
                if (data.additional.baseprice) {
                    this.baseprice = parseFloat(data.additional.baseprice.replace(/,/, '.'));
                }
                if (data.additional.standard) {
                    this.standard = data.additional.standard === 'true';
                }
                if (data.additional.sub20) {
                    this.sub20 = data.additional.sub20 === 'true';
                }
                if (data.additional.subscriptionType) {
                    this.subscriptionType = data.additional.subscriptionType;
                }
                if (data.additional.tariffLevel) {
                    this.tariffLevel = parseInt(data.additional.tariffLevel, 10);
                }
            }
            else {
                if (data.baseprice) {
                    this.baseprice = data.baseprice;
                }
                if (data.standard) {
                    this.standard = data.standard === 'true';
                }
                if (data.sub20) {
                    this.sub20 = data.sub20 === 'true';
                }
                if (data.subscriptionType) {
                    this.subscriptionType = data.subscriptionType;
                }
                if (data.tariffLevel) {
                    this.tariffLevel = parseInt(data.tariffLevel, 10);
                }
            }
            if (data.backendId) {
                this.backendId = data.backendId;
            }
        }
    }
    Tariff.prototype.loadJSON = function (json) {
        this.id = json.id ? json.id : this.id;
        this.label = json.label ? json.label : this.label;
        this.baseprice = json.baseprice ? json.baseprice : this.baseprice;
        this.standard = json.standard ? json.standard : this.standard;
        this.sub20 = json.sub20 ? json.sub20 : this.sub20;
        this.subscriptionType = json.subscriptionType ? json.subscriptionType : this.subscriptionType;
        this.tariffLevel = json.tariffLevel ? json.tariffLevel : this.tariffLevel;
        this.topSmartphoneDeals = json.topSmartphoneDeals ? json.topSmartphoneDeals : this.topSmartphoneDeals;
        this.backendId = json.backendId ? json.backendId : this.backendId;
    };
    Tariff.prototype.toJSON = function () {
        return {
            id: this.id,
            label: this.label,
            baseprice: this.baseprice,
            standard: this.standard,
            sub20: this.sub20,
            subscriptionType: this.subscriptionType,
            tariffLevel: this.tariffLevel,
            topSmartphoneDeals: this.topSmartphoneDeals,
            backendId: this.backendId
        };
    };
    Tariff.prototype.getKIASCode = function () {
        var match;
        if (this.backendId) {
            for (var _i = 0, _a = this.backendId; _i < _a.length; _i++) {
                var backendId = _a[_i];
                if (backendId.system === 'KIAS') {
                    match = backendId.value;
                }
            }
        }
        return match;
    };
    Tariff.prototype.getVluxId = function () {
        var match;
        if (this.backendId) {
            for (var _i = 0, _a = this.backendId; _i < _a.length; _i++) {
                var backendId = _a[_i];
                if (backendId.system === 'VLUX') {
                    match = backendId.value;
                }
            }
        }
        return match;
    };
    Tariff.prototype.getCurrentVersion = function () {
        return this;
    };
    return Tariff;
}());
export { Tariff };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/tariff/tariff.ts
// module id = null
// module chunks = 